// The component on the individual basket page that includes the user's volunteer
// fee and delivery fee.
import React, { useEffect, useContext, useState } from "react";
import ParticipationFeesPopOver from "./ParticipationFeesPopover.jsx";
import DeliveryChargePopover from "../../MarketplacePage/Components/DeliveryChargePopover.jsx";
import { NonFoodCostsContext } from "../../Basket.js";
import CalcHubStats from "../../../functions/CalcHubStats.js";

export default function AdditionalFees({
  costTotal,
  pickupLocation,
  suggestedFees,
  packageFeeTotal,
  communityLocation,
  currentStatus,
  deliveryFee,
  userInfo,
}) {
  const { setCashPortion, setCreditPortion } = useContext(NonFoodCostsContext);

  // This is the dollar amount owed for the volunteer fee.  It can be paid using
  // cash or credits.
  const [volunteerDollarAmount, setVolunteerDollarAmount] = useState(0);

  const [, baseDeliveryFee, minDeliveryFee] = CalcHubStats(
    userInfo,
    currentStatus,
  );
  // Calculates volunteer Fee and sets the cash and credits portions to their defaults.
  useEffect(() => {
    // Calculate the total volunteer fee.
    const volunteerDollarAmountTemp =
      ((costTotal + suggestedFees) * pickupLocation.volunteerPercentage) / 100;
    // set the cash portion to the total volunteer amount owed.
    setCashPortion(parseFloat(volunteerDollarAmountTemp).toFixed(2));
    // Set the credit portion to 0.00
    setCreditPortion(parseFloat(0).toFixed(2));
    // set the volunteer amount in the hook.
    setVolunteerDollarAmount(parseFloat(volunteerDollarAmountTemp));
  }, [costTotal, suggestedFees]);

  // Calculates volunteer Fee and sets the cash and credits portions to their defaults.
  useEffect(() => {
    // Calculate the total volunteer fee.
    const volunteerDollarAmountTemp =
      ((costTotal + suggestedFees) * pickupLocation?.volunteerPercentage) / 100;
    // set the volunteer amount in the hook.
    setVolunteerDollarAmount(parseFloat(volunteerDollarAmountTemp));
  }, [costTotal, suggestedFees]);

  return (
    <div>
      {packageFeeTotal > 0 && (
        <p className="Total-Fees">
          Total Package Fees: ${packageFeeTotal.toFixed(2)}
        </p>
      )}

      {!!communityLocation?.pickupLocation && (
        <>
          {currentStatus[2] ? (
            <p className="Total-Fees">
              <s>Delivery Charge:</s>
              <p
                style={{
                  margin: "0px 0px 0px 5px",
                  fontSize: "10px",
                  color: "gray",
                }}
              >
                Adding to existing order
              </p>
            </p>
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "right",
                justifyContent: "end",
                minWidth: "225px",
              }}
            >
              <DeliveryChargePopover
                baseDeliveryFee={baseDeliveryFee.toFixed(2)}
                minDeliveryFee={minDeliveryFee.toFixed(2)}
              />
              <p className="Total-Fees">
                Delivery Charge: ${deliveryFee.toFixed(2)}
              </p>
            </div>
          )}
        </>
      )}

      {pickupLocation?.volunteerPercentage !== undefined && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            right: "45px",
            color: "red",
            width: "260px",
          }}
        >
          <ParticipationFeesPopOver />
          <p style={{ margin: "5px 0px" }}></p> Participation Fee{" "}
          {pickupLocation?.volunteerPercentage}% : $
          {volunteerDollarAmount.toFixed(2)}{" "}
        </div>
      )}
    </div>
  );
}
